import React from "react";
import { Plus, X, Users } from "lucide-react";
import { StaffPicker } from "./StaffPicker";

export const CO_STAFF_FIELDS = ["manager", "onlineManager", "designer"];
export const CO_STAFF_MAX = 3;
export const emptyCoStaff = () => ({ manager: [], onlineManager: [], designer: [] });
/** 主负责人变更后：协办名单剔除新主负责人 */
export const dropPrimary = (co, field, primary) => ({ ...co, [field]: (co?.[field] || []).filter((n) => n !== primary) });

/** 美国岗位「协办同事」：仅在职员工，自动排除主负责人，每岗位 ≤ 3 人 */
export function CoStaffPicker({ value = [], onChange, options = [], primary = "", lang = "zh", testid, disabled = false }) {
  const zh = lang === "zh";
  const add = (n) => { if (n && !value.includes(n) && n !== primary && value.length < CO_STAFF_MAX) onChange([...value, n]); };
  const remove = (n) => onChange(value.filter((x) => x !== n));
  const roleOf = (n) => { const o = options.find((x) => x.name === n); return o ? (zh ? o.roleZh : o.roleEn) : ""; };
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-1.5" data-testid={testid}>
      <span className="inline-flex items-center gap-1 text-[10px] text-slate-400"><Users className="h-3 w-3" />{zh ? "协办" : "Co-assist"}</span>
      {value.map((n) => (
        <span key={n} data-testid={`${testid}-chip-${n}`} className="inline-flex items-center gap-1 rounded-full bg-indigo-50 border border-indigo-100 pl-2 pr-1 py-0.5 text-[11px] text-indigo-800">
          <span className="font-medium">{n}</span>
          {roleOf(n) && <span className="text-[9px] text-indigo-400">{roleOf(n)}</span>}
          {!disabled && <button type="button" onClick={() => remove(n)} data-testid={`${testid}-remove-${n}`} aria-label={zh ? `移除 ${n}` : `Remove ${n}`}
            className="rounded-full p-0.5 text-indigo-400 hover:bg-indigo-100 hover:text-indigo-700 transition-colors"><X className="h-3 w-3" /></button>}
        </span>
      ))}
      {!disabled && value.length < CO_STAFF_MAX && (
        <StaffPicker value="" onChange={add} options={options} lang={lang} testid={`${testid}-add`} hideNone exclude={[primary, ...value]}
          trigger={
            <button type="button" data-testid={`${testid}-add`}
              className="inline-flex items-center gap-0.5 rounded-full border border-dashed border-slate-300 px-2 py-0.5 text-[11px] text-slate-500 hover:border-indigo-400 hover:text-indigo-600 transition-colors">
              <Plus className="h-3 w-3" />{zh ? "添加协办同事" : "Add co-assist"}
            </button>
          } />
      )}
      {value.length >= CO_STAFF_MAX && <span className="text-[10px] text-slate-400" data-testid={`${testid}-max`}>{zh ? `最多 ${CO_STAFF_MAX} 人` : `Max ${CO_STAFF_MAX}`}</span>}
    </div>
  );
}
